import React, {useContext, useEffect, useState} from "react";
import {UserContext} from "../../../../Contexts/UserContext";
import {useTranslation} from "react-i18next";
import {ScreenWidthContext} from "../../../../Contexts/ScreenWidthContext";
import {getCoreRowModel, getPaginationRowModel, useReactTable} from "@tanstack/react-table";
import ResponsiveTable from "../../../../Components/ResponsiveTable";
import {useNavigate, useOutlet, useParams} from "react-router-dom";

export default function ReceiverList({setBreadcrumb}: any): React.ReactElement {
    const userContext   = useContext(UserContext);
    const {t}           = useTranslation();
    const screenWidth   = useContext(ScreenWidthContext);
    const navigate      = useNavigate();
    const outlet        = useOutlet();
    const {receiver_id} = useParams();

    useEffect(() => {
        if (outlet){
            const receiverName =  userContext && userContext.user ? userContext?.user.receiver.contractor.receivers.find((receiver : any) => parseInt(receiver.id) === parseInt(receiver_id as string))?.name : '';

            setBreadcrumb(
                [
                    {name: t('layout.user-menu.merchant-limit'), path: null},
                    {name: t('user-page.merchant-limit.tabs.general'), path: '/user/merchant-limit'},
                    {name: receiverName, path: null},
                ]
            );
        }
    }, [receiver_id]);

    const columns = [
        {
            header: t('user-page.merchant-limit.receiver-index'),
            accessorKey: 'hurtId',
        },
        {
            header: t('user-page.invoice.receiver'),
            accessorKey: 'name'
        },
        {
            header: t('user-page.merchant-limit.address'),
            accessorKey: 'address',
            cell: ({getValue, row}: {getValue: any, row: any}) => {
                return (
                    <>
                        {getValue().street}<br/>
                        {getValue().postalCode}, {getValue().city}
                    </>
                );
            }
        },
        {
            header: t('user-page.merchant-limit.config'),
            accessorKey: 'id',
            cell: ({getValue, row}: {getValue: any, row: any}) => {
                return(
                    <>
                       <button className={'btn'} onClick={() => navigate('/user/merchant-limit/'+getValue()) } >
                           <i className={'fas fa-edit'} /> {t('user-page.merchant-limit.edit')}
                       </button>
                    </>
                );
            }
        },
    ];

    const table = useReactTable({
        data: userContext && userContext.user ? userContext.user.receiver.contractor.receivers : [],
        columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
    });

    return (
        <>
            {outlet ?? (
                <ResponsiveTable maxColumns={screenWidth < 500 ? 2 : 3} table={table} additionalBottom={null}  />
            )}
        </>
    );
}